import {useMemo} from "react";
import {Countertop} from "../types/Countertop";
import {EstimateProductQty} from "../types/EstimateProductQty";
import {isSmallJobArea, SMALL_JOB_AREA} from "../utils/small-project-fee-rules";

function getShapeSquareFootage(shape: Countertop): number {
    return shape.total ?? 0;
}

export interface UseSmallJobsReturn {
    estimateItems: EstimateProductQty[];
}

export function useSmallJobs(shapes: Countertop[], _dealerID: number, _customerZip: string, highLimit?: number): UseSmallJobsReturn {
    const pricedShapes = useMemo(() => shapes.filter((shape) => shape.productID !== null), [shapes]);

    return useMemo(() => {
        const smallJobThreshold = highLimit ?? SMALL_JOB_AREA.DEFAULT_HIGH;
        const totalMaterialArea = pricedShapes.reduce((acc, shape) => acc + getShapeSquareFootage(shape), 0);
        const isSmallJob = isSmallJobArea(totalMaterialArea, smallJobThreshold);

        const resolvedFeeProductID = pricedShapes.find((shape) => shape.smallProductFeeID !== undefined)?.smallProductFeeID;
        const isSmallJobWithFee = isSmallJob && resolvedFeeProductID != null && resolvedFeeProductID !== undefined;

        const estimateItems: EstimateProductQty[] = isSmallJobWithFee
            ? [
                  {
                      productId: resolvedFeeProductID,
                      quantity: 1,
                      customDescription: undefined,
                  },
              ]
            : [];

        return {estimateItems};
    }, [pricedShapes, highLimit]);
}